import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { DELETE_DMX_DEVICE_PRESET } from './actionTypes';
import { deleteDmxDevicePresetSuccessful, deleteDmxDevicePresetFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* deleteDevicePreset({ payload: { preset } }) {
  try {
    const response = yield call(dmxAPI.deleteDevicePreset, preset.token, preset.deviceId, preset.id);
    if (response.message) {
      yield put(deleteDmxDevicePresetSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deleteDmxDevicePresetFailed(error));
  }
}

export function* watchDeleteDmxDevicePreset() {
  yield takeEvery(DELETE_DMX_DEVICE_PRESET, deleteDevicePreset);
}

function* deleteDmxDevicePresetSaga() {
  yield all([fork(watchDeleteDmxDevicePreset)]);
}

export default deleteDmxDevicePresetSaga;
